/*
 * Author: zhanghj
 * Date: 2020-09-27 10:59:11
 * LastEditors: zhanghj
 * LastEditTime: 2020-09-27 17:53:12
 */
import React, { useState } from 'react';
import { List, InputItem, TextareaItem } from 'antd-mobile';
import styles from './index.less';

function TextArea(props) {
  const {
    form: { 
      getFieldProps,
      getFieldValue,
    },
  } = props.props;
  const [show, setShow] = useState(false);
  const [inputValue, setInputValue] = useState(null);
  const [textareaValue, setTextAreaValue] = useState(null);

  const save = () => {
    const value = getFieldValue('textarea')
    setInputValue(value)
    setShow(false)
  }

  return (
    <>
      <List onClick={() => setShow(true)}>
        <InputItem
          type="type"
          placeholder="请输入"
          disabled
          {...getFieldProps('text', {
            initialValue: inputValue,
            rules: [
              {
                required: true,
                message: `请输入`,
              },
            ],
          })}
        />
      </List>
      
      {show && (
        <div className={styles.layerWrap}>
          <div className={styles.pickWrap}>
            <div className={styles.top}>
              多行文本
              <span className={styles.cancelBtn} onClick={() => setShow(false)}>
                取消
              </span>
            </div>
            <TextareaItem
              rows={6}
              count={1000}
              {...getFieldProps('textarea', {
                initialValue: textareaValue,
                onChange(value) {
                  setTextAreaValue(value);
                },
              })}
            />
            <div className={styles.btn} onClick={() => save()}>
              保存
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default TextArea;
